/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.7.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { getAuth0Token, getVectorBaseUrl, transformApiResult, transformRequestOptions } from './VectorClientHelpers';
export class VectorClientBase { 

    protected transformOptions(options: any) {
        return this.getToken().then(newToken => transformRequestOptions(newToken, options));
      }
  
  protected transformResult(url: string, response: Response, processor: (response: Response) => any) {
    return transformApiResult(url, response, processor);
  }

  protected getBaseUrl(urlTemplate: string, defaultUrl: string | undefined): string {
    return getVectorBaseUrl(urlTemplate, defaultUrl);
  }

  private async getToken() {
    return getAuth0Token();
  }
}

export interface IUsersClient {
    /**
     * @return Success
     */
    profiles(): Promise<UserProfileApiModel>;
}

export class UsersClient extends VectorClientBase implements IUsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    profiles(): Promise<UserProfileApiModel> {
        let url_ = this.baseUrl + "/api/userinfo/Profiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProfiles(_response));
        });
    }

    protected processProfiles(response: Response): Promise<UserProfileApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileApiModel>(<any>null);
    }
}

export class UserProfileApiModel implements IUserProfileApiModel {
    username?: string | undefined;
    email?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;

    constructor(data?: IUserProfileApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
        }
    }

    static fromJS(data: any): UserProfileApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        return data; 
    }
}

export interface IUserProfileApiModel {
    username?: string | undefined;
    email?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}